declare var swal: any;
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FacilityDetailInfoController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { FacilityDetailInfoRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { ConsumptionEntrypipe } from '../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';



@Component({
  selector: 'printlayoutNoHeader',
  templateUrl: './printlayoutNoHeader.component.html',
  styleUrls: ['./printlayoutNoHeader.component.css']
})

export class  PrintlayoutNoHeaderComponent implements OnInit {

  //@Input() FormattedCode: string;
  public Date: Date;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public ClientHeaderFooterLine1: string = "";
  public ClientHeaderFooterLine2: string = "";
  public ClientHeaderFooterLine3: string = "";
  public ClientHeaderFooterLine4: string = "";

  public logo: string = "";
  public HeaderLine1: string = "";
  public HeaderLine2: string = "";
  public GST: string;
  public DL: string;
  public PatientId: any;
  public Branchname: string;
  public BillNumber: any;

 
  constructor(private router: Router,
    private loaderService: SpinnerService,    
    private actorservice: ActorService,    
    public printService: PrintService,
    private route: ActivatedRoute,
    //private parserFormatter: NgbDateParserFormatter,
  )
  {
    //this.myAngularxQrCode = 'this.FormattedCode';
  }


  ngOnInit() {

  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

 
 
 


 
}
